import React, { useState, useEffect, useContext } from "react";
import PropTypes from "prop-types";
import { useMsal } from "@azure/msal-react";
import { Box, Typography, CircularProgress } from "@mui/material";
import CarrierProfileEquipmentItem from "./CarrierProfileEquipmentItem/CarrierProfileEquipmentItem";
import CarrierProfileAddEquipmentModal from "./CarrierProfileAddEquipmentModal/CarrierProfileAddEquipmentModal";
import useEquipmentTypes from "../../../hooks/useEquipmentTypes/useEquipmentTypes";
import { CarrierService } from "../../../services/CarrierService";
import { AlertContext } from "../../Dashboard/Dashboard";

export default function CarrierProfileEquipment({ activeCarrier }) {
  const { instance } = useMsal();
  const { warning } = useContext(AlertContext);
  const { priorityTypes } = useEquipmentTypes();
  const [carrierEquipmentTypes, setCarrierEquipmentTypes] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [carrier, setCarrier] = useState({});
  const [totalTrailers, setTotalTrailers] = useState(0);
  const [totalTractors, setTotalTractors] = useState(0);
  const [disableAll, setDisableAll] = useState(false);

  const handleDeleteEquipment = (equipment) => {
    let types = [...carrierEquipmentTypes];
    const index = types.findIndex(type => type.id === equipment.id);
    types.splice(index, 1);
    setCarrierEquipmentTypes(types);
  };

  const reorderTypes = (types) => {
    const filteredPriorityTypes = types.filter(t => priorityTypes.includes(t.equipmentTypeId));
    const filteredOtherTypes = types.filter(t => !priorityTypes.includes(t.equipmentTypeId));

    setCarrierEquipmentTypes([...filteredPriorityTypes, ...filteredOtherTypes]);
  };

  const getCarrierEquipment = () => {
    setIsLoading(true);
    CarrierService.GetCarrierEquipment(instance, carrier.id).then(res => {
      reorderTypes(res);
      setIsLoading(false);
    }).catch(error => {
      console.error(error);
      setIsLoading(false);
      warning(error);
    });
  };

  useEffect(() => {
    if (carrier.id) {
      getCarrierEquipment();
    }

    setTotalTrailers(carrier.ownedTrailers + carrier.leasedTrailers);
    setTotalTractors(carrier.ownedTractors + carrier.leasedTractors);
  }, [carrier]);

  useEffect(() => {
    if (activeCarrier.id !== carrier.id) {
      setCarrier(activeCarrier);
    }
  }, [activeCarrier]);

  return (
    <Box>
      <Box>
        <Typography variant="h4" color="black_opacity.100">
          Equipment Type
        </Typography>
      </Box>
      {isLoading ? (
        <Box sx={{ display: "flex", justifyContent: "center", marginTop: "20px" }}>
          <CircularProgress sx={{ color: "primary.60" }} size={40} />
        </Box>
      ) : (
        <Box>
          <Box>
            <CarrierProfileEquipmentItem
              equipment={{
                equipmentTypeName: "Power Units",
                equipmentCount: activeCarrier.powerUnits
              }}
              disabled
            />
            <CarrierProfileEquipmentItem
              equipment={{
                equipmentTypeName: "Tractors",
                equipmentCount: totalTractors
              }}
              disabled
            />
            <CarrierProfileEquipmentItem
              equipment={{
                equipmentTypeName: "Trailers",
                equipmentCount: totalTrailers
              }}
              disabled
            />
            {carrierEquipmentTypes.map((equipment) => (
              <CarrierProfileEquipmentItem
                key={`equipment-${equipment.id}`}
                equipment={equipment}
                disabled={disableAll}
                handleDeleteEquipment={handleDeleteEquipment}
                setDisableAll={setDisableAll}
              />
            ))}
          </Box>
          <CarrierProfileAddEquipmentModal
            existingTypes={carrierEquipmentTypes}
            activeCarrier={activeCarrier}
            refreshEquipment={getCarrierEquipment}
          />
        </Box>
      )}
    </Box>
  );
}

CarrierProfileEquipment.propTypes = {
  activeCarrier: PropTypes.object.isRequired
};